
import contactBanner from "../../../assets/images/contact-banner-min.png" ;
import ContactForm from "./free-alerts-form/free-alerts-form";
import "./free-alerts-section.scss" ;

const FreeAlertsSection = (props) => {
    return (
        <section
            ref={props.anchor}
            className="position-relative"
            id="free-alerts"
            // style={{
            //     backgroundImage: `url(${contactBanner})`,
            //     backgroundPosition: "center",
            //     backgroundSize : "cover",
            //     backgroundRepeat : "no-repeat"
            // }}
        >   
            <div style={{
                position:"absolute",
                top:"0",
                left : "0",
                width:"100%",
                height:"65%",
                backgroundImage: `url(${contactBanner})`,
                backgroundPosition: "center",
                backgroundSize : "cover",
                backgroundRepeat : "no-repeat",
            }}></div>
            <div className="container-xl position-relative" style={{ padding: "6rem 1rem",zIndex:"1" }}>
                <div className="content mx-0 mx-md-3">
                    <div className="text align-self-start"> 
                        <h6 className="text-primary">
                            STAY ALERT
                        </h6>
                        <h2 className="text-inverse">
                            Never miss your <br />
                            Continuing Professional <br />
                            development (CPD) <br />
                            or License/Certificate <br />
                            renewal again
                        </h2>
                        <p className="text-subheading text-inverse" style={{maxWidth:"50ch"}}>
                        Our automated data matching picks up your renewal dates and sends you free alerts to your phone and email address to alert you that your deadlines are fast approaching. iComply has got your back.
                        </p>
                    </div>
                    <div className="form">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FreeAlertsSection;
